/* Top level history page. This page should get all titles from MongoDB and show them. Upon
   clicking on a title, a component should then show that entry. That component should be
   re-used on any page where a history entry needs to be shown. */

import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import Box                                      from "@material-ui/core/Box"
import Grid                                     from "@material-ui/core/Grid"
import GuestBioHistoryEntryReadComponent        from './GuestBioHistoryEntryReadComponent.js'
import { node_server }                          from '../Helpers/index.js'
import ModalComponent                           from './ModalComponent.js'

const HistoryEntries = () => {

   const [ id,                                  setId                ]  =  useState('')
   const [ isOpen,                              setIsOpen            ]  =  useState(false)
   const [ displayEntries,                      setDisplayEntries    ]  =  useState([])

   const closeModal = () => {
      setIsOpen(false)
   }

   /* This shows the available Historical Entries from the history collection in MongoDB. */
   useEffect(() => {
      console.log('HistoryEntries useEffect is running')
      axios.get(node_server + 'history/')
         .then( res => res.data )
         .then( data => {
            // console.log('<HistoryEntries /> are', data)
            setDisplayEntries(data.map( d => {
               // console.log('<HistoryEntries /> id and _id are', id, d._id)
               // console.log('<HistoryEntries entries are', d)
               return(
               <Grid key={d._id} >
                  <GuestBioHistoryEntryReadComponent entry={d} />
               </Grid>
               )
            }))
         })
         .catch( ( error, msg ) => {
            console.error('error and msg are', error, msg)
         } )
   }, [] )

   return (
      <Box>
         <Grid style={{ marginTop: '6rem', padding: '2rem' }} >
            { displayEntries }
         </Grid>
         { isOpen ? <ModalComponent closeModal={closeModal} id={id} /> : null }
      </Box>
   )
}

export default HistoryEntries
